"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.ReadModeComposite = void 0;
var _react = _interopRequireDefault(require("react"));
var _FormattedComposite = require("../../Elements/FormattedComposite/FormattedComposite");
var _IconLabel = require("../../Elements/IconLabel/IconLabel");
var _IconClickable = require("../../Elements/IconClickable/IconClickable");
var _ReadMode = require("../ReadMode/ReadMode");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */

function renderErrorComposite(data, onErrorHandle, errorLinkTo, clkErrorLabel, errorLabel) {
  const onErrorClick = () => {
    onErrorHandle(data);
  };
  const labelCssClass = onErrorHandle ? 'error-interactive' : 'error';
  if (onErrorHandle && data) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconClickable.IconClickable, {
      handleClick: onErrorClick,
      id: "Error",
      lblContainerCssModifier: "inline",
      clkContainerCssModifier: "error",
      leftIcon: {
        color: 'error',
        size: 'sm',
        type: 'error'
      },
      link: errorLinkTo
      // link={{
      //   to: errorLinkTo,
      // }}
      ,
      text: clkErrorLabel,
      labelCssClass: labelCssClass
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconLabel.IconLabel, {
    id: "Error",
    lblContainerCssModifier: "inline",
    leftIcon: {
      color: 'error',
      size: 'sm',
      type: 'error'
    },
    text: errorLabel
  });
}
const ReadModeComposite = props => {
  const {
    id,
    errorLinkTo,
    value,
    validators,
    onErrorHandle,
    clkErrorLabel,
    errorLabel,
    title,
    data,
    dataFormat,
    isInlineError,
    missingTag,
    formatters,
    ...otherProps
  } = props;
  const detail = missingTag && !isInlineError ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "ccl-e-read-mode-composite__element__error",
    children: renderErrorComposite(missingTag, onErrorHandle, errorLinkTo, clkErrorLabel, errorLabel)
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedComposite.FormattedComposite, {
    "data-nw-rmc-format": dataFormat,
    "data-nw-rmc-value": id,
    config: {
      format: value,
      mustacheFormatters: formatters,
      type: 'composite'
    },
    data: data
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ...otherProps,
    className: "ccl-e-read-mode-composite__element",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ReadMode.ReadMode, {
      "data-nw-rmc-label": id,
      details: [detail],
      title: title
    }), missingTag && isInlineError ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "ccl-e-read-mode-composite__element__error",
      children: renderErrorComposite(missingTag, onErrorHandle, errorLinkTo, clkErrorLabel, errorLabel)
    }) : undefined]
  });
};
exports.ReadModeComposite = ReadModeComposite;
ReadModeComposite.defaultProps = {
  id: '',
  errorLinkTo: null,
  value: '',
  validators: [],
  onErrorHandle: undefined,
  clkErrorLabel: '',
  errorLabel: '',
  title: '',
  data: {},
  dataFormat: undefined,
  isInlineError: false,
  missingTag: undefined
};